





















































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { IGame, GamePlatform } from '~/store/games/types';
import { IUser } from '~/store/profile/types';
import GameActionButton from '~/components/Games/GameActionButton.vue';
import GameRequiredItemButton from '~/components/Games/GameRequiredItemButton.vue';
import GameMobilePlaytestButton from '~/components/Games/GameMobilePlaytestButton.vue';
import { CheckForRequiredItems, GameActionButtonHost } from '~/mixins';
import GamesBrandedModalFull from '~/components/UIComponents/GamesBrandedModalFull.vue';

@Component({
  components: {
    GameActionButton,
    GameRequiredItemButton,
    GameMobilePlaytestButton,
    GamesBrandedModalFull,
  },
})
export default class PotentialGameActionButton extends Mixins(
  CheckForRequiredItems,
  GameActionButtonHost,
) {
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @Prop(Object) readonly game!: IGame;
  @Prop(Boolean) readonly shouldUpdateColorOnHover!: boolean;
  @Prop(Boolean) readonly lowercaseText!: boolean;

  @Action('getUserItems', { namespace: 'inventory' })
  private getUserItems!: (collection: string) => void;

  isCheckingRequiredItems: boolean = true;
  requireItemButton: boolean = true;
  iosReg = /i(Phone|Pad|Pod)/gi;
  androidReg = /Android/gi;
  userIsIOS: boolean = this.iosReg.test((navigator as any).userAgent);
  userIsAndroid: boolean = this.androidReg.test((navigator as any).userAgent);
  userIsMobile: boolean = this.userIsIOS || this.userIsAndroid;
  isGameActionButtonVisible: boolean = true;
  showDesktopGameAvailabilityModal = false;

  get fetchingReqItem() {
    return this.isCheckingRequiredItems;
  }

  get requireItemButtonStatus() {
    return this.requireItemButton;
  }

  get usePlayButtonRedirect() {
    return (
      this.game?.usePlayButtonRedirect && this.game?.playButtonRedirectLink
    );
  }

  get isGameOnlyReleasedOnDesktop() {
    if (
      !this.game.isReleased ||
      this.game.hasApkFile ||
      this.game.hasIOSDownload ||
      (this.game.platform.includes(GamePlatform.Browser) &&
        this.game.isReleased &&
        this.game.playLink)
    ) {
      return false;
    } else if (
      ((this.game.platform.includes(GamePlatform.Win) &&
        this.game.isWinReleased) ||
        (this.game.platform.includes(GamePlatform.Mac) &&
          this.game.isMacReleased)) &&
      this.game.isReleased
    ) {
      return true;
    }
    return false;
  }

  get releasedDesktopPlatforms() {
    let platforms = '';

    if (this.game.isReleased) {
      if (
        this.game.platform.includes(GamePlatform.Mac) &&
        this.game.isMacReleased
      ) {
        platforms = 'Mac';
      }

      if (
        this.game.platform.includes(GamePlatform.Win) &&
        this.game.isWinReleased
      ) {
        platforms = platforms ? platforms + ' or PC' : 'PC';
      }
    }
    return platforms ? platforms : 'desktop';
  }

  created() {
    this.gameActionButtonHostCreated();

    this.$on(this.launcherMessageProcessedEventName, () => {
      const thisGameInstallationStatus = this.gamesInstallStatuses[
        this.game.codeName
      ];
      if (thisGameInstallationStatus) {
        this.game.isInstalled = thisGameInstallationStatus.isInstalled;
        this.game.installedVersion = thisGameInstallationStatus.version;
      }
    });

    this.getUserItems(this.game.collection);
  }

  mounted() {
    if (this.currentUser.loggedIn) {
      this.$store.subscribe(({ type }) => {
        if (type === 'inventory/updateUserItems') {
          this.setRequiredGameItemStatus();
        }
      });
    } else {
      this.setRequiredGameItemStatus();
    }
  }

  destroyed() {
    this.gameActionButtonHostDestroyed({ disableAutoReconnect: true });
  }

  setRequiredGameItemStatus() {
    this.requireItemButton = this.getRequiredGameItemStatus(this.game);
    this.isCheckingRequiredItems = false;
  }

  updateGameActionButtonVisiblility(showButton: boolean) {
    this.isGameActionButtonVisible = showButton;
  }
}
